import { doc, getDoc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './config';

// Kullanıcı detaylarını getir
export const getUserDetails = async (email) => {
  try {
    const userRef = doc(db, 'users', email);
    const userDoc = await getDoc(userRef);
    
    if (!userDoc.exists()) {
      throw new Error('User not found');
    }

    return userDoc.data();
  } catch (error) {
    console.error('Error fetching user details:', error);
    throw error;
  }
};

// Telefon numarasını güncelle
export const updatePhoneNumber = async (email, phone) => {
  try {
    const userRef = doc(db, 'users', email);
    await updateDoc(userRef, {
      phone,
      updatedAt: serverTimestamp()
    });
    return true;
  } catch (error) {
    console.error('Error updating phone number:', error);
    throw error;
  }
};

// Fatura bilgilerini güncelle
export const updateBillingInfo = async (email, address) => {
  try {
    const userRef = doc(db, 'users', email);
    await updateDoc(userRef, {
      billingInfo: {
        address
      },
      updatedAt: serverTimestamp()
    });
    return true;
  } catch (error) {
    console.error('Error updating billing info:', error);
    throw error;
  }
};

// Ödeme metodunu güncelle
export const updatePaymentMethod = async (email, paymentDetails) => {
  try {
    const userRef = doc(db, 'users', email);
    await updateDoc(userRef, {
      paymentMethod: {
        cardHolder: paymentDetails.cardHolder,
        lastFourDigits: paymentDetails.cardNumber.slice(-4),
        expiry: paymentDetails.expiry,
        updatedAt: serverTimestamp()
      },
      updatedAt: serverTimestamp()
    });
    return true;
  } catch (error) {
    console.error('Error updating payment method:', error);
    throw error;
  }
};

// Üyelik durumunu güncelle
export const updateMembershipStatus = async (email, status) => {
  try {
    const userRef = doc(db, 'users', email);
    await updateDoc(userRef, {
      membershipStatus: status,
      membershipUpdatedAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    });
    return true;
  } catch (error) {
    console.error('Error updating membership status:', error);
    throw error;
  }
};

// Üyelik tarihini güncelle
export const updateMembershipDates = async (email, { startDate, endDate }) => {
  try {
    const userRef = doc(db, 'users', email);
    await updateDoc(userRef, {
      membershipStartDate: startDate,
      membershipEndDate: endDate,
      updatedAt: serverTimestamp()
    });
    return true;
  } catch (error) {
    console.error('Error updating membership dates:', error);
    throw error;
  }
};

// Profil fotoğrafını güncelle
export const updateProfilePhoto = async (email, photoURL) => {
  try {
    const userRef = doc(db, 'users', email);
    await updateDoc(userRef, {
      photoURL,
      updatedAt: serverTimestamp()
    });
    return true;
  } catch (error) {
    console.error('Error updating profile photo:', error);
    throw error;
  }
};

// Display name güncelle
export const updateDisplayName = async (email, displayName) => {
  try {
    const userRef = doc(db, 'users', email);
    await updateDoc(userRef, {
      displayName,
      updatedAt: serverTimestamp()
    });
    return true;
  } catch (error) {
    console.error('Error updating display name:', error);
    throw error;
  }
};

// Kullanıcı rolünü güncelle
export const updateUserRole = async (email, role) => {
  try {
    const userRef = doc(db, 'users', email);
    await updateDoc(userRef, {
      role,
      updatedAt: serverTimestamp()
    });
    return true;
  } catch (error) {
    console.error('Error updating user role:', error);
    throw error;
  }
};